'use client'

import * as PopoverPrimitive from '@radix-ui/react-popover'

import { TimeRangeFilterContent } from './components/TimeRangeFilterContent'
import { TimeRangeFilterCustomAndActions } from './components/TimeRangeFilterCustomAndActions'
import { TimeRangeFilterTrigger } from './components/TimeRangeFilterTrigger'
import { useTimeRangeFilter } from './hooks/useTimeRangeFilter'
import type { ServiceMapTimeRangeFilterProps } from './time-range.types'

export function ServiceMapTimeRangeFilter({
  id,
  disabled = false,
  sideOffset = 8,
  ...rest
}: ServiceMapTimeRangeFilterProps) {
  const filter = useTimeRangeFilter({ disabled, ...rest })

  return (
    <PopoverPrimitive.Root open={filter.isOpen} onOpenChange={filter.handleOpenChange}>
      <PopoverPrimitive.Trigger asChild>
        <TimeRangeFilterTrigger
          id={id}
          triggerLabel={filter.triggerLabel}
          disabled={disabled}
          isOpen={filter.isOpen}
          ariaTitle={filter.resolvedLabels.title}
        />
      </PopoverPrimitive.Trigger>
      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
          className={filter.panelClass}
          side={filter.side}
          align={filter.align}
          sideOffset={sideOffset}
          collisionPadding={8}
          role="dialog"
          aria-label={filter.resolvedLabels.title}
        >
          <TimeRangeFilterContent
            title={filter.resolvedLabels.title}
            pendingValue={filter.pendingValue}
            onPendingValueChange={filter.handlePendingValueChange}
            gridColumns={filter.gridColumns}
          />
          <TimeRangeFilterCustomAndActions
            showCustomSection={filter.showCustomSection}
            pendingRange={filter.pendingRange}
            sectionLabels={filter.sectionLabels}
            hour12={filter.hour12}
            dateFormat={filter.dateFormat}
            onStartDateChange={filter.setStartDate}
            onStartTimeChange={filter.setStartTime}
            onEndDateChange={filter.setEndDate}
            onEndTimeChange={filter.setEndTime}
            cancelLabel={filter.resolvedLabels.cancel}
            applyLabel={filter.resolvedLabels.apply}
            canApplyCustom={filter.canApplyCustom}
            onCancel={filter.handleCancel}
            onApply={filter.handleApply}
          />
        </PopoverPrimitive.Content>
      </PopoverPrimitive.Portal>
    </PopoverPrimitive.Root>
  )
}
